import React, { useEffect, useRef, useState } from 'react';
import Cardacademy  from '../../components/CategoryCard.js';
import DashboardCard from '../../components/TituloDashboard.js'; // Asegúrate de que la ruta sea correcta
import studentPhoto from '../../img/user-profile.png';
import util from '../../utils/generalFunctions.js'
import 'moment/locale/es';
import moment from 'moment';
import agendaService from '../../services/agendaService.js';
import Loading from '../../components/Loading.js';
import { Link } from 'react-router-dom';
import DocumentItem from '../../components/documentItem.js';

moment.locale('es');


  const DashboardEstudiantePc = () => {

    const [showLoading, setShowLoading] = useState(false);
    const [agenda, setAgenda] = useState([]);
    const eventos = [...agenda].map((row) => {
        
      return {
          id: row.agendaId,
          title: row.title,
          description:row.description,
          start: row.startDate,
          end:row.endDate,
          journey:row.journeyName,
          year:row.schoolYearName,
          educationLevel:row.educationLevelName,
          grade:row.gradeName,
          course:row.courseName,
          student:row.studentName,
          documents:row.documents,
          backgroundColor: row.colorAleatorio, // Color del fondo
          borderColor: row.colorAleatorio,     // Color del borde
          textColor: '#ffffff'             // (opcional) Color del texto, si quieres forzar que sea legible
      };
  });

  const studentInfo = util.getStudentInformation();
  useEffect(() => {
          BuscarAgenda(null);
  }, []);

  const BuscarAgenda = async (e) =>{
          if(e) e.preventDefault();
          setShowLoading(true);
          setAgenda([]);
            try {

              const data = await agendaService.getAgenda(
                studentInfo.schoolYearId, 
                studentInfo.journeyId,
                studentInfo.educationLevelId, 
                studentInfo.gradeId,
                studentInfo.courseId, 
                studentInfo.studentId, 
                moment().startOf('month').format("yyyy-MM-DD"), 
                moment().endOf('month').format("yyyy-MM-DD")); // Obtenemos los estudiantes de tu sistema
                
              if(data && data.length>0){
                setAgenda(data);
              }else{
                setAgenda([]); 
              }
            } catch (error) {
              console.error("Error al obtener horario:", error);
            }
            setShowLoading(false);// Cambia el estado a false una vez que los datos se carguen
    }

  const chartContainerStyle = {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      width: '100%',
      padding: '10px'
  };

  return (
    
    <div style={chartContainerStyle} className='row '>
                  <DashboardCard
          studentPhoto={studentPhoto} // Usar la variable importada aquí
          title={"Te damos la Bienvenida, "+(studentInfo?.firstName??'')+"!"}
          subtitle="Dashboard school"
        />
            
            
      <div className="cardcate">
        <Cardacademy title="Hoja de Vida" icon="fa-user" link="/dashboard-estudiantepc/perfil" className="grades-card" /> 
        {studentInfo?.educationLevelId!==1 && (
          <Cardacademy title="Calificaciones" icon="fa-chart-simple" link="/dashboard-estudiantepc/Notas" className="students-card"/>
        )}        
        {studentInfo?.educationLevelId===1 && (
          <Cardacademy title="Logros" icon="fa-solid fa-award" link="/dashboard-estudiante/calificaciones-estudiante-pre" className="students-card"/> 
        )}
        <Cardacademy title="Estado de Cuenta" icon="fa-solid fa-coins" link="/dashboard-estudiantepc/estado-de-cuenta" className="students-card"/>
        <Cardacademy title="Agenda" icon="fa-solid fa-calendar-check" link="/agenda-estudiante" className="students-card"/>
        <Cardacademy title="Seguimiento" icon="fa-person-circle-exclamation" link="/dashboard-estudiantepc/observador-asistencia" className="students-card"/>
        <Cardacademy title="Horario" icon="fa-calendar-days" link="/dashboard-estudiantepc/horario-de-clases" className="students-card"/>
        <Cardacademy title="Reportes" icon="fa-solid fa-chart-pie" link="/reportes-estudiantepc" className="students-card"/>


        {/* Puedes añadir más categorías según sea necesario */}
      </div>
      <div className="col-lg-6 col-md-12 mb-4">
  <div className="card shadow-lg border-0 rounded-4 h-100 animate__animated animate__fadeIn">

    {/* Header con colores vivos */}
    <div className="card-header bg-warning rounded-top-4 py-4 d-flex justify-content-between align-items-center">
      <h4 className="card-title mb-0 d-flex align-items-center fs-3 text-white">
        <span role="img" aria-label="agenda" className="me-3 fs-2">📒</span>
        Agenda de {moment().startOf('month').format("MMMM YYYY")}
      </h4>
    </div>

    {/* Loading Spinner */}
    {showLoading && (
      <div className="d-flex justify-content-center align-items-center p-4">
        <Loading />
      </div>
    )}

    {/* Body */}
    {!showLoading && (
      <>
        <div 
          className="card-body p-4 bg-light" 
          style={{ maxHeight: '450px', overflowY: 'auto' }}
        >
          {eventos.length > 0 ? (
            eventos.slice(0, 3).map((evento) => (
              <div 
                key={evento.id} 
                className="event-item d-flex justify-content-between align-items-start mb-4 p-4 bg-white rounded-4 shadow-sm transition-all hover-bounce"
                style={{ cursor: 'pointer', borderLeft: '8px solid #f39c12' }}
              >
                <div className="flex-grow-1 pe-3">
                  
                  {/* Título del evento */}
                  <h5 className="fw-bold mb-2 text-primary fs-4">
                    🏫 {evento.title}
                  </h5>

                  {/* Descripción */}
                  <p className="text-secondary mb-3 fs-5">
                    <div dangerouslySetInnerHTML={{ __html: evento.description }} />    
                  </p>

                  <table className='w-auto ml-20 mt-20'>
                  {evento.documents && evento.documents.length> 0 && evento.documents?.map((doc) => (
                      <DocumentItem 
                          document={doc}
                          ReadOnly={true}
                          EnableDelete={true}
                          deleteDocument={null}
                      />
                  ))}
              </table>

                  {/* Fechas */}
                  <div className="text-muted fs-6">
                    <span role="img" aria-label="calendar">🗓️</span> {moment(evento.start).format('D MMM')} - {moment(evento.end).format('D MMM')}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-muted text-center fs-4 mb-0">
              No hay eventos programados 💤
            </p>
          )}
        </div>

        {/* Footer con botón llamativo */}
        <div className="card-footer bg-light border-top-0 text-center px-4 py-3">
          <Link to="/agenda-estudiante" className="btn btn-lg rounded-pill px-4 fw-bold" style={{ backgroundColor: '#e74c3c', color: 'white' }}>
            📅 Ver Agenda
          </Link>
        </div>
      </>
    )}
  </div>
</div>




     </div>      
      
  );
};

export default DashboardEstudiantePc;
